import React from 'react';
import clsx from 'clsx';

interface CardOrderTodayItemProps {
  item: any;
}

const CardOrderTodayItem = ({
  item,
}: CardOrderTodayItemProps) => {

    if (!item) return null;

    const hasSubitems = item.subitems && item.subitems.length > 0;
    return (
        <div className="flex justify-between leading-tight text-xs py-1 gap-1">
            <div className="flex w-full">
                <span className="min-w-6">{item.quantity}x</span>
                <div className='grid gap-1 w-full'>
                    <span className={clsx(hasSubitems && 'font-semibold pb-0.5')} dangerouslySetInnerHTML={{__html: item.name.replace(/<br\s*\/?>/gi, ' ')}} />
                    {hasSubitems && item.subitems?.map((subitem: any, index: number) => (
                        <div className='grid w-full' key={`subitem-${index}`}>
                            <div className="flex gap-1 text-xs leading-tight">
                                <span className="min-w-6">{subitem.quantity}x</span>
                                <span dangerouslySetInnerHTML={{__html: subitem.name.replace(/<br\s*\/?>/gi, ' ')}} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CardOrderTodayItem;